<button nbButton ghost [routerLink]="pageUrl" status="dark" routerDirection="backward">
    <nb-icon icon="arrow-back-outline"></nb-icon>
    {{ label ? label : ''}}
</button>